import { configureStore } from '@reduxjs/toolkit'
import authData from '../store/authData'
import userLogin from '../store/userLogin'
import dataRoute from '../store/dataRoute'
import orderDetail from '../store/orderDetail'
import orderItems from '../store/orderItems'
import productDetail from  '../store/productDetail'
import packageDetail from '../store/packageDetail'
import userDetail from '../store/userDetail'

export const store = configureStore({
  reducer: {
    auth: authData,
    user_login: userLogin,
    route: dataRoute,
    order_detail: orderDetail,
    order_items: orderItems,
    product_detail: productDetail,
    package_detail: packageDetail,
    user_detail: userDetail
  },
})
